import ReactDOM from "react-dom";
import * as React from "react";
import "./styles.scss";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
